import React, { Component } from 'react'

class TextInputFieldControlled extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: this.props.type,
            name: this.props.name,
            pattern: this.props.pattern,
            placeholder: this.props.placeholder,
            required: this.props.required,
            autoComplete: this.props.autoComplete,
            onChangeParent: this.props.onChangeParent,
            saveResponse: this.props.saveResponse,
            valueType: this.props.valueType,
            value: this.props.value
        }

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.setState({
            value: e.target.value,
        });
    }

    render() {      
        return (
            <input
                type={this.state.type}
                name={this.state.name}
                pattern={this.state.pattern}
                placeholder={this.state.placeholder}
                required={this.state.required}
                autoComplete={this.state.autoComplete}
                onChange={this.onChange}
                data-save={this.state.saveResponse}
                data-value-type={this.state.valueType}
                value={this.state.value}
            />
        );
    }
}

export default TextInputFieldControlled
